export default {
  placeholder: 'Wähle ein Datenformat',
};
